/**
 * Zweck: Beschreibt class SectionTitleButton und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shared/models/section-title-button.ts.
 */
export class SectionTitleButton {
  label: string;
  title: string;
  icon: string;
  onclick: any;
  class: string;
}
